import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-sales-buyback-success-message',
  templateUrl: './sales-buyback-success-message.component.html'
})
export class SalesBuybackSuccessMessageComponent {
  @Output() navigateEvent = new EventEmitter();

  navigateToVerificationClient(){
    this.navigateEvent.emit();
  }
}
